//    TODO: use samchon Typia...?
import { encode } from 'cborg';

import type { SerializedArgCacheKey } from './BaseListCore';

export function defaultArgsSerialize<TArgs extends {}>(args: TArgs) {
  return encode(args).toString() as SerializedArgCacheKey;
}
